module.exports = __webpack_public_path__ + "static/img/4.a34f9be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/4.png
// module id = Pany
// module chunks = 0